import axios from 'axios'
import Cookies from 'js-cookie'

import { COOKIE_ACCESS_TOKEN_NAME } from 'constants/cookiesConsts'
import { routeBase } from 'constants/environments.constants'
import { API_BUSINESSES } from 'constants/urls'

const apiKey = `${routeBase[process.env.REACT_APP_ENVIRONMENT].businessApikey}`
const env = `${routeBase[process.env.REACT_APP_ENVIRONMENT].apiManagementOrigin}`
const axiosInstance = axios.create({
  baseURL: API_BUSINESSES,
  headers: {
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key': apiKey,
    SCOrigen: env,
    Authorization: `Bearer ${Cookies.get(COOKIE_ACCESS_TOKEN_NAME)}`,
  },
})
export const getBusinesses = () => {
  return axiosInstance.get(`${API_BUSINESSES}/businesses`)
}

export const getBusinessesStatus = (page = '1', pageSize = '10', search = '') => {
  return axiosInstance.get(
    `${API_BUSINESSES}/businesses/status/management?page=${page}&pageSize=${pageSize}&SearchBy=${search}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(COOKIE_ACCESS_TOKEN_NAME)}`,
      },
    }
  )
}
export const putStatusManagement = (
  storeId,
  businessId,
  statusId,
  rejectionReason = null,
  deactivationReason = null
) => {
  return axiosInstance.put(
    'businesses/status/management',
    {
      storeId: storeId,
      businessId: businessId,
      statusId: statusId,
      rejectionReason,
      deactivationReason,
    },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(COOKIE_ACCESS_TOKEN_NAME)}`,
      },
    }
  )
}
export const getplans = () => {
  return axiosInstance.get(`${API_BUSINESSES}/plans`, {
    headers: {
      Authorization: `Bearer ${Cookies.get(COOKIE_ACCESS_TOKEN_NAME)}`,
    },
  })
}
export const patchchangePlan = (id, credinetStoreIds) => {
  return axiosInstance.patch(
    `${API_BUSINESSES}/stores/change-plan`,
    {
      planId: id,
      credinetStoreIds: [credinetStoreIds],
    },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(COOKIE_ACCESS_TOKEN_NAME)}`,
      },
    }
  )
}
